import Promise from 'bluebird';

Promise.config({
  // Enables all warnings except forgotten return statements.
  warnings: {
    wForgottenReturn: false,
  },
});

window.Promise = Promise;
